module.exports = __webpack_public_path__ + "static/media/kz.130a3907.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kz.svg
// module id = 695
// module chunks = 0